import CommandeLabelsSidebar from "../CommandeLabelsSidebar";
import CommandeListTable from "../CommandeListTable";
import CommandePreview from "../CommandePreview";
import FiltersSideBar from "../../../layout/FiltersSideBar";

// Liste des commandes avec ses libellés et l'aperçu de la commande sélectionnée.
export function CommandeListView({ vm }) {
    const { isOverlay, isMobile, setFiltersOpen, setLabelsOpen, selectedStatuts, setSelectedStatuts, patientSearch, setPatientSearch, readFilter, setReadFilter, favoriteFilter, setFavoriteFilter, setPage, page, totalPages, context, activeLabelKey, selectCustomLabel, clearLabelSelection, currentPharmacyId, commandes, totalElements, handleEditCommande, handleSelectCommande, previewCommande, refresh, setShowCreateModal, readOverrides, handleFlagChange, activeFilterCount, previewDetail, previewLoading, setPreviewCommande, reloadPreview } = vm;
    const showListFilters = context?.showListFilters !== false && context?.filters?.validationView;
    return (
        <div className={`commande-list-preview-layout${previewCommande && !isMobile ? " commande-list-preview-layout--with-preview" : ""}`}>
            {!isOverlay && (
                <CommandeLabelsSidebar
                    activeKey={activeLabelKey}
                    onSelectLabel={selectCustomLabel}
                    onClearLabel={clearLabelSelection}
                    pharmacyId={currentPharmacyId}
                    page={page}
                    totalPages={totalPages}
                    setPage={setPage}
                    countsRefreshKey={commandes.map(commande => `${commande.id}:${commande.statut}:${commande.read}:${commande.favorite}`).join("|")}
                />
            )}
            <div className="commande-list-pane">
                <CommandeListTable
                commandes={commandes}
                totalElements={totalElements}
                page={page}
                totalPages={totalPages}
                setPage={setPage}
                onSelect={isMobile ? handleEditCommande : handleSelectCommande}
                onEdit={handleEditCommande}
                selectedCommandeId={previewCommande?.id ?? null}
                onRefresh={refresh}
                onCreate={() => setShowCreateModal(true)}
                showStatut={!!context?.showStatut}
                readOverrides={readOverrides}
                onFlagChange={handleFlagChange}
                searchQuery={patientSearch}
                showPagination={isOverlay}
                onOpenFilters={isOverlay && showListFilters ? () => setFiltersOpen(true) : undefined}
                onOpenLabels={isOverlay ? () => setLabelsOpen(true) : undefined}
                searchContent={(
                    <FiltersSideBar
                        patientSearch={patientSearch}
                        setPatientSearch={setPatientSearch}
                        setPage={setPage}
                        section="search"
                    />
                )}
                filtersContent={!isOverlay && showListFilters ? (
                    <FiltersSideBar
                        selectedStatuts={selectedStatuts}
                        setSelectedStatuts={setSelectedStatuts}
                        readFilter={readFilter}
                        setReadFilter={setReadFilter}
                        favoriteFilter={favoriteFilter}
                        setFavoriteFilter={setFavoriteFilter}
                        setPage={setPage}
                        showStatutFilter={!!context?.showStatutFilter}
                        section="filters"
                    />
                ) : null}
                hasActiveFilters={activeFilterCount > 0}
                activeFilterCount={activeFilterCount}
                />
            </div>
            {previewCommande && !isMobile && (
                <CommandePreview
                    commande={previewDetail ? { ...previewCommande, ...previewDetail } : previewCommande}
                    loading={previewLoading}
                    onEdit={handleEditCommande}
                    onClose={() => setPreviewCommande(null)}
                    onReplySent={reloadPreview}
                    showStatut={!!context?.showStatut}
                />
            )}
        </div>
    );
}
